export default {
    homeTitle1: "Skor Kredit",
    homeContent1: "Melalui metode analisis ilmiah yang ketat, menyelidiki secara komprehensif dampak terhadap individu dan keluarga, subyektif dan obyektif baik internal maupun eksternal pada lingkungan terkait, Melakukan penilaian yang komprehensif atas kemampuannya untuk memenuhi berbagai komitmen ekonomi，sehingga menghasilkan evaluasi penilaian kredit",

    homeTitle2: "Layanan data",
    homeContent2: "Berdasarkan data perilaku konsumsi pada bank, e-commerce, telekomunikasi, Konsumsi, dan sebagainya, manfaatkan teknologi canggih yang didasarkan informasi，seperti pengumpulan data secara luas dan di bantu AI untuk mengolah data secara mendalam dan menghasilkan produk baru, sehingga kami dapat menyediakan pada pelanggan solusi dan produk yang spesifik.",

    //印尼语
    creditTitle:"Kami dapat memberikan penilaian kredit terhadap suatu nomor yang diberikan, untuk membantu pengendalian risiko dalam memberikan keputusan kredit."
};

